import React from "react";
import {
    Grid,
    Paper,
    Typography,
} from "@mui/material";

import { PrimaryButton } from "../../Common";
import { trakrefFontFamily } from "../../../utils";
import useEmailAlert from "./context/useEmailAlert";

const EmailAlertTablePlaceholder = () => {
    const { onChangeModalState } = useEmailAlert();

    return (
        <Grid container component={Paper}>
            <Grid item xs={12} align='center' paddingBottom={"30px"}>
                <img
                    style={{ paddingTop: '4%' }}
                    src={"/images/email_alert_placeholder.svg"}
                    alt='No Data'
                />
                <Typography
                    variant='h5'
                    align='center'
                    sx={{
                        fontSize: '14px',
                        marginTop: '2%',
                        paddingBottom: '2%',
                        color: '#1A173B',
                        '&.MuiTypography-root': {
                            fontFamily: trakrefFontFamily
                        }
                    }}
                >
                    <>
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                            Oops… It is empty here…
                        </span>
                        <br />
                        Create a new Email Alert to get started.
                    </>
                </Typography>
                {/*<PrimaryButton buttonText="create new email alert" onClick={onChangeModalState} />*/}
            </Grid>
        </Grid>
    )
}

export default EmailAlertTablePlaceholder;